import { useCurrentPlanApi } from "@circle-react/components/SettingsApp/Plan/hooks/useCurrentPlanApi";

export const useIsAdminApiSubscriptionActive = () => {
  const { currentPlan } = useCurrentPlanApi();

  return Boolean(currentPlan?.api_billing?.is_admin_api_subscription_active);
};
